(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  /**
   * Standalone add-to-cart / quantity-stepper controller for the quick-cart
   * collection card. Does not call into or modify
   * component-accessories-selection.js — this is fully self-contained so
   * nothing about the accessories carousel section is touched.
   *
   * Binds via event delegation against #ProductGridContainer, using the
   * same data-accessories-* attributes as the accessories reference card,
   * so the markup in card-product-quickcart.liquid plugs straight in.
   */
  window.QuickCart = (function () {
    function getWrap(el) {
      return el.closest('[data-accessories-cart-wrap]');
    }

    function setBusy(wrap, state) {
      var addButton = wrap.querySelector('[data-accessories-add-button]');
      var decreaseBtn = wrap.querySelector('[data-accessories-decrease]');
      var increaseBtn = wrap.querySelector('[data-accessories-increase]');
      if (addButton) addButton.disabled = state;
      if (decreaseBtn) decreaseBtn.disabled = state;
      if (increaseBtn) increaseBtn.disabled = state;
      wrap.dataset.quickCartBusy = state ? 'true' : 'false';
    }

    function isBusy(wrap) {
      return wrap.dataset.quickCartBusy === 'true';
    }

    function showForm(wrap) {
      var form = wrap.querySelector('[data-accessories-add-form]');
      var stepper = wrap.querySelector('[data-accessories-stepper]');
      if (stepper) stepper.hidden = true;
      if (form) form.hidden = false;
    }

    function showStepper(wrap, quantity) {
      var form = wrap.querySelector('[data-accessories-add-form]');
      var stepper = wrap.querySelector('[data-accessories-stepper]');
      var countEl = wrap.querySelector('[data-accessories-count]');
      if (countEl) countEl.textContent = quantity;
      if (form) form.hidden = true;
      if (stepper) stepper.hidden = false;
    }

    function refreshCartIcon() {
      fetch('/?section_id=cart-icon-bubble')
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newBubble = doc.querySelector('#cart-icon-bubble');
          var currentBubble = document.querySelector('#cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        })
        .catch(function () {
          /* theme may not use this section id — safe to ignore */
        });
    }

    function changeQuantity(wrap, cartChangeUrl, newQuantity) {
      if (isBusy(wrap)) return;
      var variantId = wrap.getAttribute('data-variant-id');
      setBusy(wrap, true);

      fetch(cartChangeUrl.replace(/\.js$/, '') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: newQuantity }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(function () {
          setBusy(wrap, false);
          if (newQuantity <= 0) {
            showForm(wrap);
          } else {
            showStepper(wrap, newQuantity);
          }
          refreshCartIcon();
        })
        .catch(function (error) {
          console.error('[QuickCart] Cart update failed:', error.message);
          setBusy(wrap, false);
        });
    }

    function addToCart(wrap, cartAddUrl, form) {
      if (isBusy(wrap)) return;
      var addButton = wrap.querySelector('[data-accessories-add-button]');
      var originalText = addButton ? addButton.textContent : '';
      setBusy(wrap, true);
      if (addButton) addButton.textContent = 'Adding…';

      fetch(cartAddUrl.replace(/\/$/, '') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('input[name="id"]').value,
          quantity: 1,
        }),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (errorData) {
              throw new Error((errorData && errorData.description) || 'Cart add failed');
            });
          }
          return response.json();
        })
        .then(function (lineItem) {
          setBusy(wrap, false);
          if (addButton) addButton.textContent = originalText;
          var quantity = (lineItem && lineItem.quantity) || 1;
          showStepper(wrap, quantity);
          refreshCartIcon();
        })
        .catch(function (error) {
          console.error('[QuickCart] Add to cart failed:', error.message);
          setBusy(wrap, false);
          if (addButton) {
            addButton.textContent = 'Try again';
            window.setTimeout(function () {
              addButton.textContent = originalText;
            }, 1800);
          }
        });
    }

    function bind(root, cartAddUrl, cartChangeUrl) {
      if (!root || root.dataset.quickCartBound === 'true') return;
      root.dataset.quickCartBound = 'true';

      root.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-accessories-add-form]');
        if (!form) return;
        var wrap = getWrap(form);
        if (!wrap) return;
        event.preventDefault();
        addToCart(wrap, cartAddUrl, form);
      });

      root.addEventListener('click', function (event) {
        var decreaseBtn = event.target.closest('[data-accessories-decrease]');
        var increaseBtn = event.target.closest('[data-accessories-increase]');
        if (!decreaseBtn && !increaseBtn) return;

        var wrap = getWrap(event.target);
        if (!wrap) return;

        var countEl = wrap.querySelector('[data-accessories-count]');
        var current = parseInt(countEl && countEl.textContent, 10) || 1;

        if (decreaseBtn) {
          changeQuantity(wrap, cartChangeUrl, current - 1);
        } else {
          changeQuantity(wrap, cartChangeUrl, current + 1);
        }
      });
    }

    return { bind: bind };
  })();

  (function () {
    function init() {
      var container = document.getElementById('ProductGridContainer');
      if (!container || !window.QuickCart) return;
      var addUrl = container.getAttribute('data-cart-add-url') || '/cart/add';
      var changeUrl = container.getAttribute('data-cart-change-url') || '/cart/change';
      window.QuickCart.bind(container, addUrl, changeUrl);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-bind after the theme editor re-renders this section (the
    // container node is replaced, so it won't have the bound flag yet).
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  window.QuickCart = (function () {
    function getWrap(el) {
      return el.closest('[data-accessories-cart-wrap]');
    }

    function setBusy(wrap, state) {
      var addButton = wrap.querySelector('[data-accessories-add-button]');
      var decreaseBtn = wrap.querySelector('[data-accessories-decrease]');
      var increaseBtn = wrap.querySelector('[data-accessories-increase]');
      if (addButton) addButton.disabled = state;
      if (decreaseBtn) decreaseBtn.disabled = state;
      if (increaseBtn) increaseBtn.disabled = state;
      wrap.dataset.quickCartBusy = state ? 'true' : 'false';
    }

    function isBusy(wrap) {
      return wrap.dataset.quickCartBusy === 'true';
    }

    function showForm(wrap) {
      var form = wrap.querySelector('[data-accessories-add-form]');
      var stepper = wrap.querySelector('[data-accessories-stepper]');
      if (stepper) stepper.hidden = true;
      if (form) form.hidden = false;
    }

    function showStepper(wrap, quantity) {
      var form = wrap.querySelector('[data-accessories-add-form]');
      var stepper = wrap.querySelector('[data-accessories-stepper]');
      var countEl = wrap.querySelector('[data-accessories-count]');
      if (countEl) countEl.textContent = quantity;
      if (form) form.hidden = true;
      if (stepper) stepper.hidden = false;
    }

    function refreshCartIcon() {
      fetch('/?section_id=cart-icon-bubble')
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newBubble = doc.querySelector('#cart-icon-bubble');
          var currentBubble = document.querySelector('#cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        })
        .catch(function () {});
    }

    function changeQuantity(wrap, cartChangeUrl, newQuantity) {
      if (isBusy(wrap)) return;
      var variantId = wrap.getAttribute('data-variant-id');
      setBusy(wrap, true);

      fetch(cartChangeUrl.replace(/\.js$/, '') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: newQuantity }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(function () {
          setBusy(wrap, false);
          if (newQuantity <= 0) {
            showForm(wrap);
          } else {
            showStepper(wrap, newQuantity);
          }
          refreshCartIcon();
        })
        .catch(function (error) {
          console.error('[QuickCart] Cart update failed:', error.message);
          setBusy(wrap, false);
        });
    }

    function addToCart(wrap, cartAddUrl, form) {
      if (isBusy(wrap)) return;
      var addButton = wrap.querySelector('[data-accessories-add-button]');
      var originalText = addButton ? addButton.textContent : '';
      setBusy(wrap, true);
      if (addButton) addButton.textContent = 'Adding…';

      fetch(cartAddUrl.replace(/\/$/, '') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('input[name="id"]').value,
          quantity: 1,
        }),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (errorData) {
              throw new Error((errorData && errorData.description) || 'Cart add failed');
            });
          }
          return response.json();
        })
        .then(function (lineItem) {
          setBusy(wrap, false);
          if (addButton) addButton.textContent = originalText;
          var quantity = (lineItem && lineItem.quantity) || 1;
          showStepper(wrap, quantity);
          refreshCartIcon();
        })
        .catch(function (error) {
          console.error('[QuickCart] Add to cart failed:', error.message);
          setBusy(wrap, false);
          if (addButton) {
            addButton.textContent = 'Try again';
            window.setTimeout(function () {
              addButton.textContent = originalText;
            }, 1800);
          }
        });
    }

    function bind(root, cartAddUrl, cartChangeUrl) {
      if (!root || root.dataset.quickCartBound === 'true') return;
      root.dataset.quickCartBound = 'true';

      root.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-accessories-add-form]');
        if (!form) return;
        var wrap = getWrap(form);
        if (!wrap) return;
        event.preventDefault();
        addToCart(wrap, cartAddUrl, form);
      });

      root.addEventListener('click', function (event) {
        var decreaseBtn = event.target.closest('[data-accessories-decrease]');
        var increaseBtn = event.target.closest('[data-accessories-increase]');
        if (!decreaseBtn && !increaseBtn) return;

        var wrap = getWrap(event.target);
        if (!wrap) return;

        var countEl = wrap.querySelector('[data-accessories-count]');
        var current = parseInt(countEl && countEl.textContent, 10) || 1;

        if (decreaseBtn) {
          changeQuantity(wrap, cartChangeUrl, current - 1);
        } else {
          changeQuantity(wrap, cartChangeUrl, current + 1);
        }
      });
    }

    return { bind: bind };
  })();

  (function () {
    function init() {
      var container = document.getElementById('ProductGridContainer');
      if (!container || !window.QuickCart) return;
      var addUrl = container.getAttribute('data-cart-add-url') || '/cart/add';
      var changeUrl = container.getAttribute('data-cart-change-url') || '/cart/change';
      window.QuickCart.bind(container, addUrl, changeUrl);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  // When the strict search engine returns zero products, fall back to a true
  // "contains" match against the full product catalog, fetched from Shopify's
  // public /products.json endpoint (no app needed — every store has this).
  // Shopify's own search engine applies a minimum query length, so a 1-2
  // character query like "t" returns nothing from it even when matching
  // titles clearly exist. This fallback does a plain case-insensitive
  // substring check on the title instead, so it finds every product whose
  // name contains the typed letters, regardless of query length.
  //
  // Each match is built as a real card using the same "accessories-card"
  // markup and data-accessories-* hooks your existing QuickCart script
  // (further down this file) already listens for on #ProductGridContainer —
  // so the Add to Cart button on a fallback card is fully working, with no
  // second file or extra section needed.
  (function () {
    var PAGE_SIZE = 250;
    var MAX_PAGES = 4; // up to 1000 products fetched, to bound worst-case cost
    var MAX_RESULTS = 24;

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }

    function resizeImage(src, width) {
      if (!src) return src;
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    // Mirrors Shopify's own money-formatting logic so fallback cards show
    // prices in exactly the same style as the rest of the store (e.g.
    // "Rs. 5,400.00"), instead of a generic Intl currency format that
    // doesn't match the shop's configured money format.
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    function formatMoney(amount, moneyFormat) {
      var numeric = parseFloat(amount);
      if (isNaN(numeric)) return '';
      var cents = Math.round(numeric * 100);
      var format = moneyFormat || '{{amount}}';
      var placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);

      if (!placeholderMatch) {
        return format || String(numeric);
      }

      var value;
      switch (placeholderMatch[1]) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return format.replace(placeholderMatch[0], value);
    }

    function fetchAllProducts() {
      var allProducts = [];

      function fetchPage(page) {
        return fetch('/products.json?limit=' + PAGE_SIZE + '&page=' + page)
          .then(function (response) {
            if (!response.ok) throw new Error('Could not load product catalog');
            return response.json();
          })
          .then(function (data) {
            var pageProducts = (data && data.products) || [];
            allProducts = allProducts.concat(pageProducts);
            if (pageProducts.length === PAGE_SIZE && page < MAX_PAGES) {
              return fetchPage(page + 1);
            }
            return allProducts;
          });
      }

      return fetchPage(1);
    }

    var addToCartLabel = 'Add to cart';

    function renderCard(product, currencyCode) {
      var variant = (product.variants && product.variants[0]) || {};
      var variantId = variant.id || '';
      var imageSrc = product.images && product.images[0] ? product.images[0].src : null;
      var priceText = variant.price ? formatPrice(variant.price, currencyCode) : '';
      var url = '/products/' + escapeHtml(product.handle);

      var imageMarkup = imageSrc
        ? '<img src="' + escapeHtml(resizeImage(imageSrc, 400)) + '" alt="" loading="lazy" width="400" height="400">'
        : '';

      return (
        '<li class="grid__item">' +
          '<div class="accessories-card template-search__match-card" data-accessories-cart-wrap data-variant-id="' + escapeHtml(variantId) + '">' +
            '<a class="template-search__match-media" href="' + url + '">' + imageMarkup + '</a>' +
            '<div class="accessories-card__info template-search__match-info">' +
              '<a class="template-search__match-title" href="' + url + '">' + escapeHtml(product.title) + '</a>' +
              '<p class="template-search__match-price">' + escapeHtml(priceText) + '</p>' +
            '</div>' +
            '<div class="accessories-card__cart template-search__match-cart">' +
              '<form data-accessories-add-form>' +
                '<input type="hidden" name="id" value="' + escapeHtml(variantId) + '">' +
                '<button type="submit" data-accessories-add-button class="template-search__match-add">' +
                  addToCartLabel +
                '</button>' +
              '</form>' +
              '<div data-accessories-stepper hidden class="template-search__match-stepper">' +
                '<button type="button" data-accessories-decrease aria-label="Decrease quantity">−</button>' +
                '<span data-accessories-count>1</span>' +
                '<button type="button" data-accessories-increase aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }

    // The filter/sort bar's "N results" text comes from Shopify's own
    // (unfiltered) search match count, which can be higher than the number
    // of cards actually shown once results are narrowed to title matches
    // only. This re-writes that text to the real, on-screen count.
    function syncResultsCount(count) {
      if (typeof count !== 'number' || isNaN(count)) return;
      var scope = document.getElementById('main-search-filters') || document;
      var nodes = scope.querySelectorAll('span, div, p, a');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.children.length > 0) continue;
        var text = el.textContent.trim();
        if (/^[\d,]+\s+results?$/i.test(text)) {
          el.textContent = count + (count === 1 ? ' result' : ' results');
          return;
        }
      }
    }

    function init() {
      var gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer && gridContainer.dataset.countSynced !== 'true') {
        gridContainer.dataset.countSynced = 'true';
        syncResultsCount(parseInt(gridContainer.getAttribute('data-filtered-count') || '', 10));
      }

      var emptyState = document.getElementById('SearchEmptyState');
      if (!emptyState || emptyState.dataset.fallbackChecked === 'true') return;
      emptyState.dataset.fallbackChecked = 'true';

      var rawTerm = emptyState.getAttribute('data-search-term') || '';
      var term = rawTerm.trim().toLowerCase();
      if (!term) return;

      var resultsList = emptyState.querySelector('#product-grid');
      var messageWrap = document.getElementById('SearchEmptyMessage');
      if (!resultsList || !messageWrap) return;

      var currencyCode = emptyState.getAttribute('data-shop-currency') || 'USD';

      fetchAllProducts()
        .then(function (products) {
          var matches = products
            .filter(function (product) {
              return product.title && product.title.toLowerCase().indexOf(term) !== -1;
            })
            .slice(0, MAX_RESULTS);

          if (!matches.length) return;

          resultsList.innerHTML = matches
            .map(function (product) {
              return renderCard(product, currencyCode);
            })
            .join('');

          messageWrap.hidden = true;
          emptyState.classList.remove('collection--empty');

          var noResultsText = document.getElementById('SearchNoResultsText');
          if (noResultsText) noResultsText.hidden = true;

          var wrapper = document.getElementById('TemplateSearchWrapper');
          if (wrapper) wrapper.classList.remove('template-search--empty');

          syncResultsCount(matches.length);
        })
        .catch(function (error) {
          console.error('[SearchFallback] Could not load fallback results:', error.message);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
